import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog } from '@angular/material';
import { AuthService } from 'src/app/services/auth.service';
import { LoginComponent } from '../login/login.component';

@Component({
  selector: 'app-reset-password-enter-mobile',
  templateUrl: './reset-password-enter-mobile.component.html',
  styleUrls: ['./reset-password-enter-mobile.component.css']
})
export class ResetPasswordEnterMobileComponent implements OnInit {

  constructor(private authService: AuthService, private dialog: MatDialog) { }

  ngOnInit() {
  }

  onSendVerification(form: NgForm) {

    const data = new FormData();

    data.append('mobile', `+94${form.value.mobile}`);

    this.authService.resetPasswordRequestCode(data, form.value.mobile);
  }

  onLogin() {
    this.dialog.closeAll();
    this.dialog.open(LoginComponent);
  }
}
